module.exports = __webpack_public_path__ + "campaign/partner2021-minisite-1/img/pc-live.a37b7e17.svg";